<template>
  <form @submit.prevent="submitForm()" novalidate>
    <div>
      <mu-row gutter>
        <mu-col width="80" desktop="50" tablet="70">
          <mu-row gutter>
            <mu-col width="100" desktop="50" tablet="50">
              <mu-time-picker
                :label="$t('message.labelTime')"
                mode="portrait"
                fullWidth
                v-model="timeModel.time"
                :okLabel="$t('message.okText')"
                :cancelLabel="$t('message.cancelText')"
              ></mu-time-picker>
            </mu-col>
            <mu-col width="100" desktop="50" tablet="50">
              <mu-date-picker
                :label="$t('message.labelDate')"
                :okLabel="$t('message.okText')"
                :cancelLabel="$t('message.cancelText')"
                :dateTimeFormat="dateFormat"
                format="DD-MM-YYYY"
                v-model="timeModel.date"
                :maxDate="maxDate"
                fullWidth
              ></mu-date-picker>
            </mu-col>
          </mu-row>

          <mu-row style="margin-bottom: 8px" gutter>
            <mu-col width="100" desktop="100" tablet="100">
              {{reading.treatment_name}}
            </mu-col>
          </mu-row>

          <mu-row>
            <mu-col width="100" desktop="50" tablet="50">
              <mu-text-field
                v-validate="'required|max_value:2500'"
                data-vv-name="dosage"
                :errorText="errors.first('dosage')"
                :hintText="$t('message.labelDosage')"
                :label="$t('message.labelDosage')"
                :helpText="localizeRegime(reading.unit_label)"
                v-model="reading.dosage"
                fullWidth
              ></mu-text-field>
            </mu-col>
          </mu-row>
        </mu-col>
      </mu-row>
    </div>
    <mu-flat-button
      style="margin-right: 8px;"
      :label="$t('message.discardText')"
      @click.native="closeEditMode(reading)"
    ></mu-flat-button>
    <button type="submit" style="display: none"></button>
    <mu-raised-button
      @click.native="submitForm"
      :disabled="isUpdating"
      :label="isUpdating ? $t('message.updatingText') : $t('message.updateText')"
      type="button"
      secondary
    ></mu-raised-button>
  </form>
</template>
<script>



  import TrackingEditMixin from '../../../../mixins/TrackingEditMixin'
  import MedicationRegimeMixin from '../../../../mixins/Localization/MedicationRegimes';
  import MedicationApi from '../../../../api/Tracking/Medication'

  export default {
    mixins: [
      TrackingEditMixin,
      MedicationRegimeMixin
    ],
    name: 'medication-edit',
    props: {
      item: {
        type: Object,
        default: {}
      }
    },
    data() {
      return {
        isUpdating: false,
        reading: {}
      }
    },
    methods: {
      closeEditMode() {
        let self = this;
        self.$emit('closeEditPanel', self.reading);
      },
      submitForm() {
        let self = this;
        self.$validator.validateAll().then(function (valid) {
          if (valid === true) {
            self.isUpdating = true;
            MedicationApi.updateMedicationDosage(self.reading)
              .then(function (response) {
                self.reading.date_created = self.reading.date;
                self.isUpdating = false;
                self.$emit('updateReading', self.reading);
              });
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// MedicationEdit.vue?ada4f9d0